import { forwardRef } from 'react';
import cn from 'classnames';

import { type TicketRewardType } from '@/common/types/lottery';
import { TicketIcon } from '@/components/ui/TicketIcon/TicketIcon';

import { ticketRewardToTier } from '../config';
import { useCurrentLotteryTier } from '../hooks';

import css from './styles.module.scss';

interface RewardValueProps {
  className?: string;
  value: number | string;
  reward: 'usdt' | TicketRewardType;
}

const RewardValue = forwardRef<HTMLSpanElement, RewardValueProps>(
  ({ className, value, reward }, ref) => {
    const currentTicketType = useCurrentLotteryTier();
    const ticketRewards: TicketRewardType[] = [
      'silverTicket',
      'goldTicket',
      'diamondTicket',
    ];

    return (
      <div className={cn('flex h-[64px] items-end shrink-0', className)}>
        {ticketRewards.includes(reward as TicketRewardType) && (
          <TicketIcon
            type={ticketRewardToTier[reward as TicketRewardType]}
            className="size-[64px] mr-[16px]"
          />
        )}
        <span
          ref={ref}
          data-value={`${reward === 'usdt' ? '$' : ''}${value}`}
          className={cn(
            css.rewardValue,
            css[`rewardValue--${currentTicketType}`],
          )}
        >
          <span>{`${reward === 'usdt' ? '$' : ''}${value}`}</span>
        </span>
      </div>
    );
  },
);

export { RewardValue };
